import { defineStore } from 'pinia'

import type { GlobalList, GlobalListItem } from '@/types/global-list.ts'
import { getGlobalListDetail } from '@/api/global'

export const useGlobalListStore = defineStore(
  'globalListStore',
  () => {
    const loading = ref(false)
    const globalListItems = ref<GlobalList>({})

    const fetchGlobalList = async (code: string) => {
      const temp: GlobalList = { ...globalListItems.value }
      if (temp[code] === undefined) {
        temp[code] = []
      }
      if (temp[code].length === 0) {
        loading.value = true
        try {
          const res = await getGlobalListDetail({ code: code })
          if (res.message === 'SUCCESS') {
            temp[code] = res.body.map((item: GlobalListItem) => {
              return { ...item, value: Number(item.value) }
            })
          }
        } finally {
          loading.value = false
        }
      }
      globalListItems.value = { ...temp }
      return globalListItems.value
    }

    const fetchGlobalListByCodes = async (codes: string[]) => {
      await Promise.all(codes.map(code => fetchGlobalList(code)))
    }

    const getGlobalListItem = async (code: string): Promise<GlobalListItem[]> => {
      if (globalListItems.value[code] === undefined) {
        await fetchGlobalList(code)
      }
      return Promise.resolve(globalListItems.value[code])
    }

    const glToSelectOptions = (gl: GlobalListItem[]): { label: string; value: number }[] => {
      return gl.map(item => ({
        label: item.name,
        value: Number(item.value),
      }))
    }
    return {
      globalListItems,
      loading,
      fetchGlobalList,
      fetchGlobalListByCodes,
      getGlobalListItem,
      glToSelectOptions,
    }
  },
  { persist: true }
)
